import TableComponentsContainer from "../../../../components/formsAndTable/tables/reactstrapTables/tableComponents";

const TableComponents = () => {
  return <TableComponentsContainer />;
};

export default TableComponents;
